"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDropdown = void 0;
var React = __importStar(require("react"));
var lists_1 = require("../../../../src/lists");
var FormLabel_1 = require("./FormLabel");
var FormDropdown = /** @class */ (function (_super) {
    __extends(FormDropdown, _super);
    function FormDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDropdownOptions = function (options) {
            return options.map(function (option) {
                return (React.createElement("option", { key: option.value, value: option.value, hidden: option.hidden, disabled: option.hidden }, option.title));
            });
        };
        return _this;
    }
    FormDropdown.prototype.render = function () {
        var _a = this.props, name = _a.name, placeholder = _a.placeholder, label = _a.label, options = _a.options, hint = _a.hint, onChange = _a.onChange, value = _a.value, errorMessage = _a.errorMessage, hasError = _a.hasError, disabled = _a.disabled, cssClass = _a.cssClass, required = _a.required, _b = _a.hiddenDefaultOption, hiddenDefaultOption = _b === void 0 ? true : _b;
        var extendedOptions = __spreadArray([{ title: label || name, value: "", hidden: hiddenDefaultOption }], options, true);
        var selectedOptionTitle = this.getOptionTitleByValue(extendedOptions, value || label);
        return (React.createElement("div", { className: "select-wrapper ".concat(disabled ? "form-control-disabled" : "") },
            !!label &&
                React.createElement(FormLabel_1.FormLabel, { title: label, required: required, hint: hint, labelFor: label }),
            React.createElement("div", { className: "form-select-wrapper ".concat(cssClass) + (hasError ? " form-error" : "") },
                React.createElement("div", { className: "df-form-control" },
                    React.createElement("select", { className: "df-select", onChange: onChange, name: name, value: value, disabled: disabled, id: label }, this.getDropdownOptions(extendedOptions)),
                    React.createElement("label", { className: "form-selected-item" +
                            ((selectedOptionTitle === placeholder || !selectedOptionTitle) ? " placeholder-style" : "") }, selectedOptionTitle || placeholder)),
                React.createElement("span", { className: "form-message__error" },
                    errorMessage,
                    "\u00A0"))));
    };
    FormDropdown.prototype.getOptionTitleByValue = function (options, value) {
        var selectedOptionIndex = (0, lists_1.findIndex)(options, function (element) {
            return element.value === value;
        });
        if (selectedOptionIndex > -1) {
            return options[selectedOptionIndex].title;
        }
        var defaultOption = (0, lists_1.findIndex)(options, function (element) {
            return element.value === "" && element.hidden !== true;
        });
        if (defaultOption > -1) {
            return options[defaultOption].title;
        }
        return "";
    };
    return FormDropdown;
}(React.Component));
exports.FormDropdown = FormDropdown;
